"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorEnvTypeAccepted = void 0;
/**
 * When type is redis, this indicates if it can be used by task-runners for storing working data.
 * todo: refactor with AuthorEnvRunnerType
 */
var AuthorEnvTypeAccepted;
(function (AuthorEnvTypeAccepted) {
    AuthorEnvTypeAccepted["ProductionOnly"] = "prod";
    AuthorEnvTypeAccepted["DraftOnly"] = "draft";
    AuthorEnvTypeAccepted["Any"] = "anyEnv";
    AuthorEnvTypeAccepted["None"] = "none";
})(AuthorEnvTypeAccepted = exports.AuthorEnvTypeAccepted || (exports.AuthorEnvTypeAccepted = {}));
//# sourceMappingURL=script-ident.js.map